import styled from "styled-components";

export const Icon = styled.i`
  width: 24px;
  height: 24px;
  position: relative;
  /* top: 5px; */
  margin-right: 10px;
`;
